import React from "react";
import { Button } from "antd";
import { FormattedMessage } from "react-intl";
import checkMark from "../../assets/images/checkmark.png";
import { returnToApp } from "../../utils/appDeepLink";

/**
 * What the mobile WebView shows when Stripe redirects back from hosted Connect
 * onboarding.
 *
 * Stripe's `return_url` lands on `/stripe/return` with no `?token=`, so the
 * page has no identity and cannot poll the Connect status — which is why the
 * desktop screen rendered blank here. This panel deliberately shows no payout
 * status: it confirms the hand-off and gets the user back into the app, which
 * refetches the real status on focus. Stripe redirecting at all only means the
 * user finished the hosted flow, never that payouts are enabled — the copy
 * says "submitted", not "enabled", and the server stays the source of truth.
 */
export const WebViewReturnPanel = ({ userId }) => (
  <div className="d-flex flex-column align-items-center mt-5 text-center px-3">
    <img src={checkMark} alt="" className="checkmark mb-3" />
    <h4 className="fw-bold">
      <FormattedMessage id="PAYOUT_SETUP_SUBMITTED" />
    </h4>
    <p className="mt-2 text-muted">
      <FormattedMessage id="PAYOUT_SETUP_SUBMITTED_DESC" />
    </p>
    <Button
      type="primary"
      className="fw-bold mt-3"
      onClick={() => returnToApp(userId)}
    >
      <FormattedMessage id="RETURN_TO_APP" />
    </Button>
    <p className="text-muted mt-3 small">
      <FormattedMessage id="RETURN_TO_APP_HINT" />
    </p>
  </div>
);

export default WebViewReturnPanel;
